import { ICoursesFilters } from '@sdk/contracts';
import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const CourseService = sdk.getService('CourseService');

export const useAllCoursesForSelectors = (filters?: ICoursesFilters) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['courses', 'all', filters],
    queryFn: () => CourseService.findAllCoursesForSelectors(filters)
  });

  return {
    courses: data,
    isLoading,
    error
  };
};
